import type { ResponseOf } from "@apis/http/typedRoute";

export type AccountProduct = NonNullable<ResponseOf<"GET/api/tiktok-shop/account-products">["products"]>[number];

export interface ProductPickerValue {
  productId: string;
  productTitle: string;
  productImage: string;
  salesCount?: number;
  /** 设计稿出现 $19.99，接口暂未返回，预留 */
  price?: string;
}

export interface ProductPickerProps {
  linkId: number;
  value: ProductPickerValue;
  onChange: (next: ProductPickerValue) => void;
  disabled?: boolean;
}

export const toPickerValue = (product: AccountProduct): ProductPickerValue => ({
  productId: product.productId ?? "",
  productTitle: product.productTitle ?? "",
  productImage: product.imageUrl ?? "",
  salesCount: product.salesCount,
});

export const formatSalesCount = (count?: number): string | null => {
  if (count === undefined || count === null) return null;
  if (count >= 1000) {
    const k = Math.floor(count / 100) / 10;
    return `${k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)}K sold`;
  }
  return `${count} sold`;
};
